import { Payload } from "Models/UI/Payload";
import { AddonTrain } from "./AddonTrain";

export class PayloadTrain implements Payload {
  train: AddonTrain;
}
